export enum CountryTab {
  Ru = 'ru',
  Kz = 'kz',
  Rb = 'rb',
}
